import { useMutation, useQueryCache } from 'react-query';
import { CompetitionAPI } from 'api/admin/competition';
import { TOURNAMENT } from 'helpers/constants';
import dispatchToast from 'helpers/dispatchToast';

export default function useCreateCompetition() {
  const queryCache = useQueryCache();

  return useMutation(CompetitionAPI.addCompetition, {
    onSuccess: ({ message }, { onSuccess = () => {} }) => {
      dispatchToast({ message, type: 'success' });
      queryCache.invalidateQueries(TOURNAMENT);
      onSuccess();
    },
  });
}
